import React, { useEffect, useState } from "react";
import { getTokenData } from "../../services/Auth__Service";
import { findOneByLogin } from "../../services/User__Service";

const UserInfos = ({
  imgProfile = null,
  clientName = null,
  name = null,
  profil = null,
}) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const data = getTokenData();

    if (!name) {
      fetchOneUSerByLogin(data.login);
    }
  }, [name]);
  const fetchOneUSerByLogin = async (login) => {
    findOneByLogin(login).then((response) => {
      setUser(response.data);
    });
  };

  return (
    <>
      {imgProfile && (
        <div className="header__profile__image__background">
          <img
            src={URL.createObjectURL(imgProfile)}
            className="header__profile__image"
            alt="profile"
          />
        </div>
      )}

      <div className="header__info">
        <h4 className="header__name">
          {clientName
            ? clientName.length <= 15
              ? clientName
              : clientName.substring(0, 15) + "..."
            : null}
        </h4>
        {user && (
          <h6 className="header__profileName">
            {user.fullname.length <= 15
              ? user.fullname
              : user.fullname.substring(0, 15) + "..."}
          </h6>
        )}
        {name && (
          <h6 className="header__profileName">
            {name.length <= 15 ? name : name.substring(0, 15) + "..."}
          </h6>
        )}
      </div>
    </>
  );
};

export default UserInfos;
